import React from 'react'
import { TelegramIcon } from '../svgIcons/TelegramIcon'
import { TwitterIcon } from '../svgIcons/TwitterIcon'
import { DiscordIcon } from '../svgIcons/DiscordIcon'
import { useWalletContext } from './WalletContext'
import { GAtrack } from '../services/ga'

function Social() {
    const { networkName: network } = useWalletContext()

    return (
        <div
            className='flex items-center py-3 px-5 rounded-full'
            style={{
                background: 'linear-gradient(90.06deg, rgba(22, 70, 130, 0.59) 0.04%, rgba(22, 70, 130, 0.25) 99.94%)',
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
            }}>
            <a
                onClick={() => {
                    if (network === 'mainnet-alpha') GAtrack('social_clicked', 'social_clicked', 'discord', -1)
                }}
                href='https://discord.gg/gbxgWHzqE4'
                target='_blank'
                className='block mr-5'>
                <DiscordIcon className='w-5 h-5 text-white' />
            </a>
            <a
                onClick={() => {
                    if (network === 'mainnet-alpha') GAtrack('social_clicked', 'social_clicked', 'twitter', -1)
                }}
                href='https://twitter.com/mySwapxyz'
                target='_blank'
                className='mr-5'>
                <TwitterIcon className='w-5 h-5 text-white' />
            </a>
            <a
                onClick={() => {
                    if (network === 'mainnet-alpha') GAtrack('social_clicked', 'social_clicked', 'telegram', -1)
                }}
                href='https://t.me/mySwapxyz'
                target='_blank'
                className=''>
                <TelegramIcon className='w-5 h-5 text-white' />
            </a>
        </div>
    )
}

export default Social
